import { SxProps, Theme } from "@mui/material";

export const waveBoxSx = (
  height: number,
  borderRadiusPx: number
): SxProps<Theme> => ({
  width: "100%",
  height: `${height}px`,
  borderRadius: `${borderRadiusPx}px`,
  overflow: "hidden",
  userSelect: "none",
  WebkitUserSelect: "none",
  cursor: "default",
});
